import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueWindowSize from 'vue-window-size';
import App from './App.vue';
import router from './router';
import vueHeadful from 'vue-headful';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'font-awesome/css/font-awesome.css';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueWindowSize);
Vue.component('vue-headful', vueHeadful);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
